<form style="width: 400px; min-width: 50%">
  <h1 mat-dialog-title>{{ (service.isUpdateHoliday? 'Calendar.addHoliday.headerEdit': 'Calendar.addHoliday.headerNew') | translate}}</h1>
  <div mat-dialog-content>
    <div class="row">
      <mat-form-field class="col-12">
        <mat-label>{{ 'Calendar.addHoliday.lblDescription' | translate}}</mat-label>
        <input type="text" matInput placeholder="Description" [(ngModel)]="holiday.description" [ngModelOptions]="{standalone: true}" required maxlength="200"/>
      </mat-form-field>
      <mat-form-field class="col-12">
        <mat-label>{{ 'Calendar.addHoliday.lblActualDate' | translate}}</mat-label>
        <input matInput [matDatepicker]="dpActual" disabled [(ngModel)]="holiday.actualDate" [ngModelOptions]="{standalone: true}" required>
        <mat-datepicker-toggle matSuffix [for]="dpActual"></mat-datepicker-toggle>
        <mat-datepicker #dpActual disabled="false"></mat-datepicker>
      </mat-form-field>
      @if (hasStatDays) {
        <mat-form-field class="col-12">
          <mat-label>{{ 'Calendar.addHoliday.lblStatutoryDate' | translate}}</mat-label>
          <input matInput [matDatepicker]="dpStatutory" disabled [(ngModel)]="holiday.statutoryDate" [ngModelOptions]="{standalone: true}">
          <mat-datepicker-toggle matSuffix [for]="dpStatutory"></mat-datepicker-toggle>
          <mat-datepicker #dpStatutory disabled="false">
            <mat-datepicker-actions>
              <button mat-raised-button color="warn" (click)="ResetDateFilter(); dpStatutory.close()">{{'btnReset' | translate}}</button>
              <button mat-raised-button color="primary" matDatepickerApply>{{'btnOk' | translate}}</button>
            </mat-datepicker-actions>
          </mat-datepicker>
        </mat-form-field>
      }
      <mat-form-field class="col-12">
        <mat-label>{{ 'Calendar.addHoliday.lblExceptions' | translate}}</mat-label>
        <mat-select multiple [(ngModel)]="holiday.exceptions" [ngModelOptions]="{standalone: true}">
          @for (market of markets; track market) {
            <mat-option [value]="market.id">{{market.value}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="OnSaveHoliday()">{{ 'btnOk' | translate}}</button>&nbsp;
    <button mat-raised-button color="secondary" (click)="OnCancel()">{{ 'btnCancel' | translate}}</button>
  </div>
</form>
